// import React, { useEffect, useMemo, useState } from "react";
// import api from "../../api";
// import Can from "../../components/Can";
// import {
//   Table,
//   Button,
//   Form,
//   Pagination,
//   InputGroup,
//   Modal,
//   Spinner,
//   Alert,
//   Badge,
// } from "react-bootstrap";
// import "./AdminUnitPage.css";
// import "./AdminUnitPage.overrides.css";
// import { getSerialNumber } from "../../utils/pagination";
// import ApartmentOutlinedIcon from "@mui/icons-material/ApartmentOutlined";
// import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";

// export default function AdminUnitPage() {
//   const [units, setUnits] = useState([]);
//   const [name, setName] = useState("");
//   const [editId, setEditId] = useState(null);

//   const [search, setSearch] = useState("");
//   const [sortField, setSortField] = useState("id");
//   const [sortOrder, setSortOrder] = useState("asc");

//   const [currentPage, setCurrentPage] = useState(1);
//   const [unitsPerPage, setUnitsPerPage] = useState(10);

//   const [showModal, setShowModal] = useState(false);
//   const [showDeleteModal, setShowDeleteModal] = useState(false);
//   const [deleteId, setDeleteId] = useState(null);

//   const [loading, setLoading] = useState(false);
//   const [saving, setSaving] = useState(false);

//   const [message, setMessage] = useState("");
//   const [messageType, setMessageType] = useState("success");

//   useEffect(() => {
//     fetchUnits();
//   }, []);

//   const showMessage = (type, text) => {
//     setMessageType(type);
//     setMessage(text);

//     setTimeout(() => {
//       setMessage("");
//     }, 3000);
//   };

//   const fetchUnits = async () => {
//     try {
//       setLoading(true);
//       const res = await api.get(`/units`);
//       setUnits(Array.isArray(res.data) ? res.data : []);
//     } catch (error) {
//       console.error("Fetch Units Error:", error);
//       showMessage("danger", "Failed to fetch units");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const filteredUnits = useMemo(() => {
//     let data = [...units];

//     if (search.trim()) {
//       data = data.filter((unit) =>
//         unit.name?.toLowerCase().includes(search.toLowerCase())
//       );
//     }

//     data.sort((a, b) => {
//       let valueA = a[sortField];
//       let valueB = b[sortField];

//       if (sortField === "name") {
//         valueA = valueA?.toLowerCase() || "";
//         valueB = valueB?.toLowerCase() || "";
//       }

//       if (valueA < valueB) return sortOrder === "asc" ? -1 : 1;
//       if (valueA > valueB) return sortOrder === "asc" ? 1 : -1;
//       return 0;
//     });

//     return data;
//   }, [units, search, sortField, sortOrder]);

//   const totalPages = Math.ceil(filteredUnits.length / unitsPerPage);
//   const indexOfLast = currentPage * unitsPerPage;
//   const indexOfFirst = indexOfLast - unitsPerPage;
//   const currentUnits = filteredUnits.slice(indexOfFirst, indexOfLast);

//   useEffect(() => {
//     setCurrentPage(1);
//   }, [search, unitsPerPage]);

//   const handleSort = (field) => {
//     if (sortField === field) {
//       setSortOrder((prev) => (prev === "asc" ? "desc" : "asc"));
//     } else {
//       setSortField(field);
//       setSortOrder("asc");
//     }
//   };

//   const getSortIcon = (field) => {
//     if (sortField !== field) return "↕";
//     return sortOrder === "asc" ? "↑" : "↓";
//   };

//   const handleAdd = () => {
//     setName("");
//     setEditId(null);
//     setShowModal(true);
//   };

//   const handleEdit = (unit) => {
//     setName(unit.name || "");
//     setEditId(unit.id);
//     setShowModal(true);
//   };

//   const handleCloseModal = () => {
//     setShowModal(false);
//     setName("");
//     setEditId(null);
//   };

//   const handleSubmit = async () => {
//     if (!name.trim()) {
//       showMessage("danger", "Please enter unit name");
//       return;
//     }

//     try {
//       setSaving(true);

//       if (editId) {
//         await api.put(`/units/${editId}`, {
//           name: name.trim(),
//         });
//         showMessage("success", "Unit updated successfully");
//       } else {
//         await api.post(`/units`, {
//           name: name.trim(),
//         });
//         showMessage("success", "Unit added successfully");
//       }

//       handleCloseModal();
//       fetchUnits();
//     } catch (error) {
//       console.error("Save Unit Error:", error);
//       showMessage("danger", editId ? "Failed to update unit" : "Failed to add unit");
//     } finally {
//       setSaving(false);
//     }
//   };

//   const openDeleteModal = (id) => {
//     setDeleteId(id);
//     setShowDeleteModal(true);
//   };

//   const closeDeleteModal = () => {
//     setDeleteId(null);
//     setShowDeleteModal(false);
//   };

//   const confirmDelete = async () => {
//     try {
//       await api.delete(`/units/${deleteId}`);
//       showMessage("success", "Unit deleted successfully");
//       closeDeleteModal();
//       fetchUnits();
//     } catch (error) {
//       console.error("Delete Unit Error:", error);
//       showMessage("danger", "Failed to delete unit");
//     }
//   };

//   const exportCSV = () => {
//     if (!filteredUnits.length) {
//       showMessage("danger", "No data available to export");
//       return;
//     }

//     const headers = ["ID", "Name"];
//     const rows = filteredUnits.map((unit) => [unit.id, unit.name]);

//     const csvContent =
//       [headers, ...rows]
//         .map((row) =>
//           row
//             .map((value) => `"${String(value || "").replace(/"/g, '""')}"`)
//             .join(",")
//         )
//         .join("\n");

//     const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
//     const url = URL.createObjectURL(blob);

//     const link = document.createElement("a");
//     link.href = url;
//     link.download = "units.csv";
//     link.click();

//     URL.revokeObjectURL(url);
//   };

//   return (
//     <div className="unit-page unit-mgmt-theme">
//       <div className="unit-header">
//         <div>
//           <div className="unit-page-label">Configuration</div>
//           <h2>Unit Management</h2>
//           <p>Manage departments, schools, offices and operational units.</p>
//         </div>

//         <div className="unit-header-actions">
//           <Button className="unit-btn unit-btn-light" onClick={fetchUnits}>
//             <i className="fa-solid fa-rotate" aria-hidden="true"></i>
//             Refresh
//           </Button>

//           <Button className="unit-btn unit-btn-light" onClick={exportCSV}>
//             <i className="fa-solid fa-download" aria-hidden="true"></i>
//             Export CSV
//           </Button>

//           <Can moduleKey="units" actionKey="create">
//             <Button className="unit-btn unit-btn-primary" onClick={handleAdd}>
//               <i className="fa-solid fa-plus" aria-hidden="true"></i>
//               Add Unit
//             </Button>
//           </Can>
//         </div>
//       </div>

//       {message && (
//         <Alert variant={messageType} className="unit-alert">
//           {message}
//         </Alert>
//       )}

//       <div className="unit-stats-row">
//         <div className="unit-stat-card">
//           <div className="unit-stat-icon unit-stat-icon-primary">
//             <i className="fa-solid fa-building" aria-hidden="true"></i>
//           </div>
//           <div className="unit-stat-text">
//             <span>Total Units</span>
//             <strong>{units.length}</strong>
//           </div>
//         </div>

//         <div className="unit-stat-card">
//           <div className="unit-stat-icon unit-stat-icon-accent">
//             <i className="fa-solid fa-filter" aria-hidden="true"></i>
//           </div>
//           <div className="unit-stat-text">
//             <span>Filtered Result</span>
//             <strong>{filteredUnits.length}</strong>
//           </div>
//         </div>

//         <div className="unit-stat-card">
//           <div className="unit-stat-icon unit-stat-icon-success">
//             <i className="fa-solid fa-list-ol" aria-hidden="true"></i>
//           </div>
//           <div className="unit-stat-text">
//             <span>Current Page</span>
//             <strong>{currentPage}</strong>
//           </div>
//         </div>
//       </div>

//       <div className="unit-card">
//         <div className="unit-toolbar">
//           <div>
//             <h5>
//               <i className="fa-solid fa-list-ul unit-list-icon" aria-hidden="true"></i>
//               Unit List
//             </h5>
//             <p>View, search, sort, add, update and delete units.</p>
//           </div>

//           <div className="unit-toolbar-actions">
//             <InputGroup className="unit-search">
//               <InputGroup.Text aria-hidden="true">
//                 <i className="fa-solid fa-magnifying-glass"></i>
//               </InputGroup.Text>
//               <Form.Control
//                 placeholder="Search by unit name..."
//                 aria-label="Search by unit name"
//                 value={search}
//                 onChange={(e) => setSearch(e.target.value)}
//               />
//               {search && (
//                 <Button
//                   className="unit-clear-btn"
//                   onClick={() => setSearch("")}
//                 >
//                   Clear
//                 </Button>
//               )}
//             </InputGroup>

//             <Form.Select
//               className="unit-page-size"
//               value={unitsPerPage}
//               onChange={(e) => setUnitsPerPage(Number(e.target.value))}
//             >
//               <option value={5}>5 rows</option>
//               <option value={10}>10 rows</option>
//               <option value={20}>20 rows</option>
//               <option value={50}>50 rows</option>
//             </Form.Select>
//           </div>
//         </div>

//         <div className="unit-table-wrapper">
//           {loading ? (
//             <div className="unit-loader">
//               <Spinner animation="border" />
//               <p>Loading units...</p>
//             </div>
//           ) : (
//             <Table responsive className="unit-table">
//               <thead>
//                 <tr>
//                   <th style={{ width: 70 }}>S.NO.</th>
//                   <th onClick={() => handleSort("name")} className="sortable">
//                     Unit Name {getSortIcon("name")}
//                   </th>
//                   <th>Status</th>
//                   <th className="text-end">Actions</th>
//                 </tr>
//               </thead>

//               <tbody>
//                 {currentUnits.length > 0 ? (
//                   currentUnits.map((unit, index) => (
//                     <tr key={unit.id}>
//                       <td>{getSerialNumber(index, currentPage, unitsPerPage)}</td>

//                       <td>
//                         <div className="unit-name-box">
//                           <div className="unit-letter">
//                             {unit.name?.charAt(0)?.toUpperCase()}
//                           </div>
//                           <div>
//                             <strong>{unit.name}</strong>
//                             <small>Unit ID: {unit.id}</small>
//                           </div>
//                         </div>
//                       </td>

//                       <td>
//                         <Badge className="unit-status">Active</Badge>
//                       </td>

//                       <td>
//                         <div className="unit-actions">
//                           <Can moduleKey="units" actionKey="edit">
//                             <Button
//                               className="unit-icon-btn unit-edit"
//                               onClick={() => handleEdit(unit)}
//                               title="Edit"
//                               aria-label={`Edit ${unit.name || "unit"}`}
//                             >
//                               <i className="fa-solid fa-pen" aria-hidden="true"></i>
//                             </Button>
//                           </Can>

//                           <Can moduleKey="units" actionKey="delete">
//                             <Button
//                               className="unit-icon-btn unit-delete"
//                               onClick={() => openDeleteModal(unit.id)}
//                               title="Delete"
//                               aria-label={`Delete ${unit.name || "unit"}`}
//                             >
//                               <i className="fa-solid fa-trash" aria-hidden="true"></i>
//                             </Button>
//                           </Can>
//                         </div>
//                       </td>
//                     </tr>
//                   ))
//                 ) : (
//                   <tr>
//                     <td colSpan="4">
//                       <div className="unit-empty">
//                         <div className="unit-empty-icon">
//                           <i className="fa-solid fa-building" aria-hidden="true"></i>
//                         </div>
//                         <h5>No units found</h5>
//                         <p>Try another keyword or add a new unit.</p>
//                         <Button className="unit-btn unit-btn-primary" onClick={handleAdd}>
//                           <i className="fa-solid fa-plus" aria-hidden="true"></i>
//                           Add Unit
//                         </Button>
//                       </div>
//                     </td>
//                   </tr>
//                 )}
//               </tbody>
//             </Table>
//           )}
//         </div>

//         <div className="unit-footer">
//           <div className="unit-count-text">
//             Showing{" "}
//             <strong>
//               {filteredUnits.length === 0 ? 0 : indexOfFirst + 1}
//             </strong>{" "}
//             to{" "}
//             <strong>
//               {Math.min(indexOfLast, filteredUnits.length)}
//             </strong>{" "}
//             of <strong>{filteredUnits.length}</strong> entries
//           </div>

//           {totalPages > 1 && (
//             <Pagination className="unit-pagination">
//               <Pagination.Prev
//                 disabled={currentPage === 1}
//                 onClick={() => setCurrentPage((prev) => prev - 1)}
//               />

//               {[...Array(totalPages)].map((_, i) => (
//                 <Pagination.Item
//                   key={i + 1}
//                   active={i + 1 === currentPage}
//                   onClick={() => setCurrentPage(i + 1)}
//                 >
//                   {i + 1}
//                 </Pagination.Item>
//               ))}

//               <Pagination.Next
//                 disabled={currentPage === totalPages}
//                 onClick={() => setCurrentPage((prev) => prev + 1)}
//               />
//             </Pagination>
//           )}
//         </div>
//       </div>

//       <Modal
//         show={showModal}
//         onHide={handleCloseModal}
//         centered
//         className="unit-modal"
//         dialogClassName="admin-teal-modal"
//         backdropClassName="admin-teal-backdrop"
//       >
//         <Modal.Header closeButton closeLabel="Close">
//           <div className="d-flex align-items-center">
//             <ApartmentOutlinedIcon className="modal-header-icon" aria-hidden="true" />
//             <Modal.Title>{editId ? "Edit Unit" : "Add New Unit"}</Modal.Title>
//           </div>
//         </Modal.Header>

//         <Modal.Body>
//           <Form.Group>
//             <Form.Label>Unit Name</Form.Label>
//             <Form.Control
//               type="text"
//               placeholder="Example: Corporate Office"
//               value={name}
//               onChange={(e) => setName(e.target.value)}
//               autoFocus
//             />
//           </Form.Group>
//         </Modal.Body>

//         <Modal.Footer>
//           <Button className="unit-btn unit-btn-light" onClick={handleCloseModal}>
//             Cancel
//           </Button>

//           <Button
//             className="unit-btn unit-btn-primary"
//             onClick={handleSubmit}
//             disabled={saving}
//           >
//             {saving ? "Saving..." : editId ? "Update Unit" : "Create Unit"}
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       <Modal
//         show={showDeleteModal}
//         onHide={closeDeleteModal}
//         centered
//         className="unit-modal"
//         dialogClassName="admin-teal-modal admin-teal-modal-sm admin-teal-modal-danger"
//         backdropClassName="admin-teal-backdrop"
//       >
//         <Modal.Header closeButton closeLabel="Close">
//           <Modal.Title>Delete Unit?</Modal.Title>
//         </Modal.Header>

//         <Modal.Body>
//           <div className="admin-modal-danger-icon" aria-hidden="true">
//             <DeleteOutlineIcon fontSize="inherit" />
//           </div>
//           <p className="unit-delete-text text-center">
//             Are you sure you want to delete this unit? This action cannot be undone.
//           </p>
//         </Modal.Body>

//         <Modal.Footer>
//           <Button className="unit-btn unit-btn-light" onClick={closeDeleteModal}>
//             Cancel
//           </Button>

//           <Button className="unit-btn unit-btn-danger" onClick={confirmDelete}>
//             Delete
//           </Button>
//         </Modal.Footer>
//       </Modal>
//     </div>
//   );
// }






import React, { useEffect, useMemo, useState } from "react";
import { compactPageItems } from "../../components/ui/compactPagination";
import api from "../../api";
import Can from "../../components/Can";
import {
  Table,
  Button,
  Form,
  Pagination,
  InputGroup,
  Modal,
  Spinner,
  Alert,
  Badge,
} from "react-bootstrap";
import "./AdminUnitPage.css";
import "./AdminUnitPage.overrides.css";
import { getSerialNumber } from "../../utils/pagination";

export default function AdminUnitPage() {
  const [units, setUnits] = useState([]);
  const [name, setName] = useState("");
  const [editId, setEditId] = useState(null);

  const [search, setSearch] = useState("");
  const [sortField, setSortField] = useState("id");
  const [sortOrder, setSortOrder] = useState("asc");

  const [currentPage, setCurrentPage] = useState(1);
  const [unitsPerPage, setUnitsPerPage] = useState(10);

  const [showModal, setShowModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState(null);

  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);

  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState("success");

  useEffect(() => {
    fetchUnits();
  }, []);

  const showMessage = (type, text) => {
    setMessageType(type);
    setMessage(text);

    setTimeout(() => {
      setMessage("");
    }, 3000);
  };

  const fetchUnits = async () => {
    try {
      setLoading(true);
      const res = await api.get(`/units`);
      setUnits(Array.isArray(res.data) ? res.data : []);
    } catch (error) {
      console.error("Fetch Units Error:", error);
      showMessage("danger", "Failed to fetch units");
    } finally {
      setLoading(false);
    }
  };

  const filteredUnits = useMemo(() => {
    let data = [...units];

    if (search.trim()) {
      data = data.filter((unit) =>
        unit.name?.toLowerCase().includes(search.toLowerCase())
      );
    }

    data.sort((a, b) => {
      let valueA = a[sortField];
      let valueB = b[sortField];

      if (sortField === "name") {
        valueA = valueA?.toLowerCase() || "";
        valueB = valueB?.toLowerCase() || "";
      }

      if (valueA < valueB) return sortOrder === "asc" ? -1 : 1;
      if (valueA > valueB) return sortOrder === "asc" ? 1 : -1;
      return 0;
    });

    return data;
  }, [units, search, sortField, sortOrder]);

  const totalPages = Math.ceil(filteredUnits.length / unitsPerPage);
  const indexOfLast = currentPage * unitsPerPage;
  const indexOfFirst = indexOfLast - unitsPerPage;
  const currentUnits = filteredUnits.slice(indexOfFirst, indexOfLast);

  useEffect(() => {
    setCurrentPage(1);
  }, [search, unitsPerPage]);

  const handleSort = (field) => {
    if (sortField === field) {
      setSortOrder((prev) => (prev === "asc" ? "desc" : "asc"));
    } else {
      setSortField(field);
      setSortOrder("asc");
    }
  };

  const getSortIcon = (field) => {
    if (sortField !== field) return "↕";
    return sortOrder === "asc" ? "↑" : "↓";
  };

  const handleAdd = () => {
    setName("");
    setEditId(null);
    setShowModal(true);
  };

  const handleEdit = (unit) => {
    setName(unit.name || "");
    setEditId(unit.id);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setName("");
    setEditId(null);
  };

  const handleSubmit = async () => {
    if (!name.trim()) {
      showMessage("danger", "Please enter unit name");
      return;
    }

    try {
      setSaving(true);

      if (editId) {
        await api.put(`/units/${editId}`, {
          name: name.trim(),
        });
        showMessage("success", "Unit updated successfully");
      } else {
        await api.post(`/units`, {
          name: name.trim(),
        });
        showMessage("success", "Unit added successfully");
      }

      handleCloseModal();
      fetchUnits();
    } catch (error) {
      console.error("Save Unit Error:", error);
      showMessage("danger", editId ? "Failed to update unit" : "Failed to add unit");
    } finally {
      setSaving(false);
    }
  };

  const openDeleteModal = (id) => {
    setDeleteId(id);
    setShowDeleteModal(true);
  };

  const closeDeleteModal = () => {
    setDeleteId(null);
    setShowDeleteModal(false);
  };

  const confirmDelete = async () => {
    try {
      await api.delete(`/units/${deleteId}`);
      showMessage("success", "Unit deleted successfully");
      closeDeleteModal();
      fetchUnits();
    } catch (error) {
      console.error("Delete Unit Error:", error);
      showMessage("danger", "Failed to delete unit");
    }
  };

  const exportCSV = () => {
    if (!filteredUnits.length) {
      showMessage("danger", "No data available to export");
      return;
    }

    const headers = ["ID", "Name"];
    const rows = filteredUnits.map((unit) => [unit.id, unit.name]);

    const csvContent =
      [headers, ...rows]
        .map((row) =>
          row
            .map((value) => `"${String(value || "").replace(/"/g, '""')}"`)
            .join(",")
        )
        .join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = "units.csv";
    link.click();

    URL.revokeObjectURL(url);
  };

  return (
    <div className="unit-page unit-mgmt-theme">
      <div className="admin-unit-heading-box">
        <div className="admin-unit-heading-content">
          <div className="admin-unit-heading-icon">
            <i className="fa-solid fa-building" aria-hidden="true"></i>
          </div>

          <div>
            <div className="unit-page-label">Configuration</div>
            <h2>Unit Management</h2>
            <p>Manage departments, schools, offices and operational units.</p>
          </div>
        </div>

        <div className="unit-header-actions">
          <Button className="unit-btn unit-btn-light" onClick={fetchUnits}>
            <i className="fa-solid fa-rotate" aria-hidden="true"></i>
            Refresh
          </Button>

          <Button className="unit-btn unit-btn-light" onClick={exportCSV}>
            <i className="fa-solid fa-download" aria-hidden="true"></i>
            Export CSV
          </Button>

          <Can moduleKey="units" actionKey="create">
            <Button className="unit-btn unit-btn-primary" onClick={handleAdd}>
              <i className="fa-solid fa-plus" aria-hidden="true"></i>
              Add Unit
            </Button>
          </Can>
        </div>
      </div>

      {message && (
        <Alert variant={messageType} className="unit-alert">
          <i
            className={
              messageType === "success"
                ? "fa-solid fa-circle-check"
                : "fa-solid fa-circle-exclamation"
            }
            aria-hidden="true"
          ></i>
          <span>{message}</span>
        </Alert>
      )}

      <div className="unit-stats-row">
        <div className="unit-stat-card admin-unit-stat-blue">
          <div className="admin-unit-stat-content">
            <div className="unit-stat-text">
              <span>Total Units</span>
              <strong>{units.length}</strong>
            </div>
            <div className="unit-stat-icon">
              <i className="fa-solid fa-building" aria-hidden="true"></i>
            </div>
          </div>
        </div>

        <div className="unit-stat-card admin-unit-stat-purple">
          <div className="admin-unit-stat-content">
            <div className="unit-stat-text">
              <span>Filtered Result</span>
              <strong>{filteredUnits.length}</strong>
            </div>
            <div className="unit-stat-icon">
              <i className="fa-solid fa-filter" aria-hidden="true"></i>
            </div>
          </div>
        </div>

        <div className="unit-stat-card admin-unit-stat-green">
          <div className="admin-unit-stat-content">
            <div className="unit-stat-text">
              <span>Current Page</span>
              <strong>{currentPage}</strong>
            </div>
            <div className="unit-stat-icon">
              <i className="fa-solid fa-list-ol" aria-hidden="true"></i>
            </div>
          </div>
        </div>
      </div>

      <div className="unit-card">
        <div className="unit-toolbar">
          <div className="admin-unit-section-title">
            <div className="admin-unit-section-icon">
              <i className="fa-solid fa-table-list" aria-hidden="true"></i>
            </div>

            <div>
              <h5>Unit List</h5>
              <p>View, search, sort, add, update and delete units.</p>
            </div>
          </div>

          <div className="unit-toolbar-actions">
            <InputGroup className="unit-search">
              <InputGroup.Text aria-hidden="true">
                <i className="fa-solid fa-magnifying-glass"></i>
              </InputGroup.Text>
              <Form.Control
                placeholder="Search by unit name..."
                aria-label="Search by unit name"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
              {search && (
                <Button
                  className="unit-clear-btn"
                  onClick={() => setSearch("")}
                >
                  <i className="fa-solid fa-xmark" aria-hidden="true"></i>
                </Button>
              )}
            </InputGroup>

            <Form.Select
              className="unit-page-size"
              value={unitsPerPage}
              onChange={(e) => setUnitsPerPage(Number(e.target.value))}
            >
              <option value={5}>5 rows</option>
              <option value={10}>10 rows</option>
              <option value={20}>20 rows</option>
              <option value={50}>50 rows</option>
            </Form.Select>
          </div>
        </div>

        <div className="unit-table-wrapper">
          {loading ? (
            <div className="unit-loader">
              <Spinner animation="border" />
              <p>Loading units...</p>
            </div>
          ) : (
            <Table responsive className="unit-table">
              <thead>
                <tr>
                  <th style={{ width: 70 }}>S.NO.</th>
                  <th onClick={() => handleSort("name")} className="sortable">
                    Unit Name {getSortIcon("name")}
                  </th>
                  <th>Status</th>
                  <th className="text-end">Actions</th>
                </tr>
              </thead>

              <tbody>
                {currentUnits.length > 0 ? (
                  currentUnits.map((unit, index) => (
                    <tr key={unit.id}>
                      <td>{getSerialNumber(index, currentPage, unitsPerPage)}</td>

                      <td>
                        <div className="unit-name-box">
                          <div className="unit-letter">
                            {unit.name?.charAt(0)?.toUpperCase()}
                          </div>
                          <div>
                            <strong>{unit.name}</strong>
                            <small>Unit ID: {unit.id}</small>
                          </div>
                        </div>
                      </td>

                      <td>
                        <Badge className="unit-status admin-unit-status-active">
                          <i className="fa-solid fa-circle-check me-1" aria-hidden="true"></i>
                          Active
                        </Badge>
                      </td>

                      <td>
                        <div className="unit-actions">
                          <Can moduleKey="units" actionKey="edit">
                            <Button
                              className="unit-icon-btn unit-edit"
                              onClick={() => handleEdit(unit)}
                              title="Edit"
                              aria-label={`Edit ${unit.name || "unit"}`}
                            >
                              <i className="fa-solid fa-pen" aria-hidden="true"></i>
                            </Button>
                          </Can>

                          <Can moduleKey="units" actionKey="delete">
                            <Button
                              className="unit-icon-btn unit-delete"
                              onClick={() => openDeleteModal(unit.id)}
                              title="Delete"
                              aria-label={`Delete ${unit.name || "unit"}`}
                            >
                              <i className="fa-solid fa-trash" aria-hidden="true"></i>
                            </Button>
                          </Can>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="4">
                      <div className="unit-empty">
                        <div className="unit-empty-icon">
                          <i className="fa-solid fa-building" aria-hidden="true"></i>
                        </div>
                        <h5>No units found</h5>
                        <p>Try another keyword or add a new unit.</p>
                        <Button className="unit-btn unit-btn-primary" onClick={handleAdd}>
                          <i className="fa-solid fa-plus" aria-hidden="true"></i>
                          Add Unit
                        </Button>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          )}
        </div>

        <div className="unit-footer">
          <div className="unit-count-text">
            Showing{" "}
            <strong>
              {filteredUnits.length === 0 ? 0 : indexOfFirst + 1}
            </strong>{" "}
            to{" "}
            <strong>
              {Math.min(indexOfLast, filteredUnits.length)}
            </strong>{" "}
            of <strong>{filteredUnits.length}</strong> entries
          </div>

          {totalPages > 1 && (
            <Pagination className="unit-pagination">
              <Pagination.Prev
                disabled={currentPage === 1}
                onClick={() => setCurrentPage((prev) => prev - 1)}
              />

              {compactPageItems([...Array(totalPages)].map((_, i) => (
                <Pagination.Item
                  key={i + 1}
                  active={i + 1 === currentPage}
                  onClick={() => setCurrentPage(i + 1)}
                >
                  {i + 1}
                </Pagination.Item>
              )), currentPage)}

              <Pagination.Next
                disabled={currentPage === totalPages}
                onClick={() => setCurrentPage((prev) => prev + 1)}
              />
            </Pagination>
          )}
        </div>
      </div>

      <Modal
        show={showModal}
        onHide={handleCloseModal}
        centered
        className="unit-modal"
        dialogClassName="admin-unit-modal"
        backdropClassName="admin-unit-backdrop"
      >
        <Modal.Header closeButton closeLabel="Close">
          <div className="admin-unit-modal-heading">
            <div className="admin-unit-modal-icon">
              <i
                className={editId ? "fa-solid fa-pen-to-square" : "fa-solid fa-building-circle-arrow-right"}
                aria-hidden="true"
              ></i>
            </div>
            <div>
              <small>Unit Setup</small>
              <Modal.Title>{editId ? "Edit Unit" : "Add New Unit"}</Modal.Title>
            </div>
          </div>
        </Modal.Header>

        <Modal.Body>
          <Form.Group>
            <Form.Label>Unit Name</Form.Label>
            <Form.Control
              type="text"
              placeholder="Example: Corporate Office"
              value={name}
              onChange={(e) => setName(e.target.value)}
              autoFocus
            />
          </Form.Group>
        </Modal.Body>

        <Modal.Footer>
          <Button className="unit-btn unit-btn-light" onClick={handleCloseModal}>
            <i className="fa-solid fa-arrow-left" aria-hidden="true"></i>
            Cancel
          </Button>

          <Button
            className="unit-btn unit-btn-primary"
            onClick={handleSubmit}
            disabled={saving}
          >
            {saving ? (
              <>
                <Spinner animation="border" size="sm" />
                Saving...
              </>
            ) : (
              <>
                <i className="fa-solid fa-floppy-disk" aria-hidden="true"></i>
                {editId ? "Update Unit" : "Create Unit"}
              </>
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showDeleteModal}
        onHide={closeDeleteModal}
        centered
        className="unit-modal"
        dialogClassName="admin-unit-modal admin-unit-modal-sm admin-unit-modal-danger"
        backdropClassName="admin-unit-backdrop"
      >
        <Modal.Header closeButton closeLabel="Close">
          <div className="admin-unit-modal-heading">
            <div className="admin-unit-modal-icon admin-unit-modal-icon-danger">
              <i className="fa-solid fa-trash" aria-hidden="true"></i>
            </div>
            <div>
              <small>Delete Action</small>
              <Modal.Title>Delete Unit?</Modal.Title>
            </div>
          </div>
        </Modal.Header>

        <Modal.Body>
          <div className="admin-modal-danger-icon" aria-hidden="true">
            <i className="fa-solid fa-trash"></i>
          </div>
          <p className="unit-delete-text text-center">
            Are you sure you want to delete this unit? This action cannot be undone.
          </p>
        </Modal.Body>

        <Modal.Footer>
          <Button className="unit-btn unit-btn-light" onClick={closeDeleteModal}>
            <i className="fa-solid fa-arrow-left" aria-hidden="true"></i>
            Cancel
          </Button>

          <Button className="unit-btn unit-btn-danger" onClick={confirmDelete}>
            <i className="fa-solid fa-trash" aria-hidden="true"></i>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}